import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { from, of } from "rxjs";
import {
  catchError,
  map,
  mergeMap,
  switchMap,
  take,
  tap,
  withLatestFrom,
} from "rxjs/operators";
import { AppState, appStore } from "../../app.state";
import { LoadingService } from "../../loading/loading.service";

import {
  IAcuerdo,
  IAcuerdos,
  IAcuerdoSeleccionado,
} from "../../interfaces/acuerdos";
import { AcuerdosService } from "../../services/acuerdos/acuerdos.service";
import { ExcelFilesService } from "../../services/excel-files/excel-files.service";
import {
  aplazarTemaMrb,
  aplazarMoverQuitarTemaFail,
  aplazarMoverQuitarTemaSuccess,
  cargaAcuerdos,
  cargaAcuerdosFail,
  cargaAcuerdosSuccess,
  moverTemaMrb,
  cargaAcuerdosByTipoAcuerdo,
  loadResponsables,
  loadResponsablesSuccess,
  loadResponsablesFail,
  guardarNuevoAcuerdoMRB,
  guardarNuevoAcuerdoMRBError,
  enviarNotificacionNuevoAcuerdoMR,
  guardarNuevoAcuerdoMRSuccess,
  quitarTemaNotificarAcuerdo,
  resetAcuerdos,
} from "./actions";
import { cargarEntradas } from "../entradas/actions";
import { TemasService } from "../../services/temas/temas.service";
import {
  cancelarFormulariosAcuerdo,
  cargarDatosGuardados,
} from "../forms/actions";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { Router } from "@angular/router";
import {
  selectAcuedoActual,
  selectAllAcuerdos,
  selectTipoAcuerdo,
} from "./selector";
import { DespachoService } from "../../services/despacho/despacho.service";
import {
  consultarDespachos,
  ejeccionAccionDespachoError,
  ejeccionAccionDespachoSuccess,
  resetDespacho,
  setContador,
  setContadorSuccess,
} from "../despacho/actions";
import { cargaTemasAcuerdo } from "../temas/actions";
import {
  selectAcuerdoSelected,
  selectAcuerdoSelectedAcuerdo,
  selectAcuerdoTemas,
} from "../temas/selectors";
appStore;
@Injectable()
export class AcuerdosEffects {
  constructor(
    private actions$: Actions,
    private acuerdosService: AcuerdosService,
    private excelFilesService: ExcelFilesService,
    private store: Store<AppState>,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    public temasService: TemasService,
    public despachoService: DespachoService,
    private router: Router
  ) {}

  cargaAcuerdosByTipoAcuerdo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(cargaAcuerdosByTipoAcuerdo),
      withLatestFrom(this.store.pipe(select(selectAllAcuerdos))),
      switchMap(([{ type, tipoAcuerdo }, acuerdos]) => {
        this.loadingService.show();

        return this.acuerdosService.getAllAcuerdosByTipo(tipoAcuerdo).pipe(
          map((response: IAcuerdos) => {
            console.log("response", response);

           // this.store.dispatch(setContador());
            this.store.dispatch(cargarEntradas());

            this.loadingService.hide();
            return cargaAcuerdosSuccess({
              acuerdoActual: response.acuerdoActual,
              acuerdos: response.acuerdos,
              tipoAcuerdo: response.tipoAcuerdo,
              historico: response.historico,
            });
          }),
          catchError((error) => {
            this.loadingService.hide();
            return of(cargaAcuerdosFail());
          })
        );
      })
    )
  );

  aplazarTemaMrb$ = createEffect(() =>
    this.actions$.pipe(
      ofType(aplazarTemaMrb),
      withLatestFrom(this.store.select(selectAcuerdoTemas)),
      map(([{ aplazar }, temasAcuerdo]) => {
        const temaId = aplazar.id_tema;

        // Filtrar el tema que será aplazado
        const temasFiltrados = temasAcuerdo.filter(
          (tema) => tema.id !== temaId
        );

        console.log("temasFiltrados", temasFiltrados);
        // Si hay temas filtrados, asignar 'verTema' y 'expanded' al último tema de la lista
        // if (temasFiltrados.length > 0) {
        //   const ultimoTema = {
        //     ...temasFiltrados[temasFiltrados.length - 1],
        //     verTema: true,
        //     expanded: true,
        //   };
        //   console.log("ultimoTema", ultimoTema);
        //   // Crear una nueva lista de temas, actualizando el último tema
        //   return temasFiltrados.map((tema) =>
        //     tema.id === ultimoTema.id
        //       ? { ...tema, verTema: true, expanded: true } // Asignar los valores correctos al tema aplazado
        //       : tema
        //   );
        // }
        return temasFiltrados;
      }),
      tap((temas) => {
        console.log("temas", temas);
        this.store.dispatch(aplazarMoverQuitarTemaSuccess());
      }),
      map((temas) => cargarDatosGuardados({ temas }))
    )
  );

  loadResponsables$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadResponsables),
      switchMap(() => {
        this.loadingService.show();
        console.log("loadResponsables...");
        return this.despachoService.getResponsablesFB().pipe(
          map((response) => {
            console.log(
              "loadResponsables response=>>>>>>>>>>>",
              response.responsables
            );

            const responsables = response.responsables;

            this.loadingService.hide();
            return loadResponsablesSuccess({
              nuevoAcuerdo: {
                show: true,
                responsables: {
                  administrador: responsables?.administrador || [],
                  analista: responsables?.analista || [],
                  coordinador: responsables?.coordinador || [],
                  supervisor: responsables?.supervisor || [],
                },
              },
            });
          }),
          catchError((error) => {
            this.loadingService.hide();
            return of(loadResponsablesFail());
          })
        );
      })
    )
  );

  guardarNuevoAcuerdoMRB$ = createEffect(() =>
    this.actions$.pipe(
      ofType(guardarNuevoAcuerdoMRB),
      map(({ acuerdo, notiAcuerdo, notiNuevoTema }) => {
        console.log("acuerdo", acuerdo);
        console.log("notiAcuerdo", notiAcuerdo);
        console.log("notiNuevoTema", notiNuevoTema);
        this.dialog.closeAll();

        this.store.dispatch(
          loadResponsablesSuccess({
            nuevoAcuerdo: {
              show: false,
              responsables: {
                administrador: [],
                analista: [],
                coordinador: [],
                supervisor: [],
              },
            },
          })
        );
        //this.showDialog("Éxito", "Acuerdo agregado correctamente.", false);
        this.store.dispatch(cargaAcuerdosByTipoAcuerdo({ tipoAcuerdo: 2 }));
        return guardarNuevoAcuerdoMRSuccess();
      }),
      catchError((error) => {
        return of(guardarNuevoAcuerdoMRBError());
      })
    )
  );
  enviarNotificacionNuevoAcuerdoMR$ = createEffect(() =>
    this.actions$.pipe(
      ofType(enviarNotificacionNuevoAcuerdoMR),
      map(({ notiAcuerdo, notiNuevoTema }) => {
        this.loadingService.show();
        this.dialog.closeAll();
        console.log("enviarNotificacionNuevoAcuerdoMR...");
        this.store.dispatch(
          loadResponsablesSuccess({
            nuevoAcuerdo: {
              show: false,
              responsables: {
                administrador: [],
                analista: [],
                coordinador: [],
                supervisor: [],
              },
            },
          })
        );
        this.showDialog("Éxito", "Acuerdo agregado correctamente.", false);
        this.store.dispatch(cargaAcuerdosByTipoAcuerdo({ tipoAcuerdo: 2 }));
        return guardarNuevoAcuerdoMRSuccess();
      }),
      catchError((error) => {
        return of(guardarNuevoAcuerdoMRBError());
      })
    )
  );

  quitarTemaNotificarAcuerdo$ = createEffect(() =>
    this.actions$.pipe(
      ofType(quitarTemaNotificarAcuerdo),
      withLatestFrom(
        this.store.pipe(select(selectTipoAcuerdo)),
        this.store.pipe(select(selectAcuerdoSelected))
      ),
      tap(() => this.loadingService.show()),
      switchMap(
        ([
          { type, quitarTema, temaEliminado },
          tipoAcuerdo,
          { acuerdo, temas, archivos },
        ]) =>
          from(this.despachoService.quitarTema(quitarTema)).pipe(
            mergeMap(() =>
              from(this.despachoService.temaEliminadoMrb(temaEliminado)).pipe(
                switchMap(() => {
                  this.loadingService.show();
                  const updateTemas = temas.filter(
                    (tema) => tema.id !== quitarTema.id_tema
                  );

                  return of(cargarDatosGuardados({ temas: updateTemas }));
                })
              )
            ),
            catchError((error) => {
              this.loadingService.hide();
              return of(ejeccionAccionDespachoError());
            })
          )
      )
    )
  );
  private showDialog(title: string, message: string, redirect: boolean): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });

    dialogRef.componentInstance.confirmAction.subscribe(() => {
      if (redirect) {
        this.router.navigate([`acuerdos-mrb-listado`]);
      }
    });
  }
}
